import { PhoneCandidateList as KitPhoneCandidateList } from '@parsina/framework';

import { useTranslation } from '../../i18n';

/**
 * The records already on one mobile number — the list every registration surface
 * shows before it creates a patient (ثبت بیمار جدید, «بیمار جدید» in ثبت نوبت,
 * «تکمیل پرونده», and each added «خود بیمار» number of a record's list, PM-0536).
 *
 * The list itself is the kit's now (`PhoneCandidateList`, promoted from this file with
 * the same props and test ids, DESIGN_CONCEPT §17): a linked record in full, any other
 * masked, and «یافته با شمارهٔ دیگر» when the number is one of that record's other
 * numbers. This wrapper only hands it this panel's words, so every caller reads the
 * catalogue it always did. Anything a caller passes in `messages` still wins.
 *
 * Actions:
 *   onChooseLinked(candidate)  a linked row — open it, or book for it. Without it
 *                              the row just says it is already the clinic's.
 *   onLink(candidate)          an unlinked row — attach it to this clinic. May throw;
 *                              the row reports the failure and stays actionable.
 *   onNewPatient()             «بیمار جدید با همین شماره».
 */
export default function PhoneCandidateList({ messages, ...props }) {
  const { t, locale } = useTranslation();
  return (
    <KitPhoneCandidateList
      locale={locale}
      messages={{
        // The kit hands both values over already in the page's digits.
        birthYear: (year) => t('patients.phoneCandidates.birthYear', { year }),
        fileNumber: (number) => t('patients.phoneCandidates.fileNumber', { number }),
        male: t('common.gender.male'),
        female: t('common.gender.female'),
        hasAppAccount: t('patients.phoneCandidates.hasAppAccount'),
        inYourList: t('patients.origin.inYourList'),
        alreadyInList: t('patients.phoneCandidates.alreadyInList'),
        addToList: t('patients.phoneCandidates.addToList'),
        adding: t('patients.phoneCandidates.adding'),
        linkFailed: t('patients.phoneCandidates.linkFailed'),
        newOnSameNumber: t('patients.phoneCandidates.newOnSameNumber'),
        matchedOther: t('patients.phones.matchedOther'),
        ...messages,
      }}
      {...props}
    />
  );
}
